import { AdminTypeProps, CompanyDetails, Detail, RegisterStrategy, SaveAdminData } from 'store/admins/types';

class ClubStrategy implements RegisterStrategy {
  private readonly clubId: string;

  constructor(clubId: string) {
    this.clubId = clubId;
  }

  getDataEndpoint(): string {
    return `/api/v1/broker-management/clubs/${this.clubId}`;
  }

  getDetails(data: any): Detail[] {
    return [{ label: 'Company name', value: data.data.name }];
  }

  mapDataForSave(data: CompanyDetails): SaveAdminData {
    return {
      first_name: data.firstName,
      last_name: data.surname,
      email: data.email,
      phone: data.contactNumber,
      club: this.clubId,
      additional_permissions: 'NO',
    };
  }
}

class FirmStrategy implements RegisterStrategy {
  private readonly fcaNumber: string;

  constructor(fcaNumber: string) {
    this.fcaNumber = fcaNumber;
  }

  getDataEndpoint(): string {
    return `/api/v1/broker-management/company-data/${this.fcaNumber}`;
  }

  getDetails(data: any): Detail[] {
    return [
      { label: 'FCA Registration Number', value: this.fcaNumber },
      { label: 'Company name', value: data.company_name },
    ];
  }

  mapDataForSave(data: CompanyDetails): SaveAdminData {
    return {
      first_name: data.firstName,
      last_name: data.surname,
      email: data.email,
      phone: data.contactNumber,
      fca_number: this.fcaNumber,
      additional_permissions: data.additionalPermissions || 'NO',
    };
  }
}

export const createStrategy = (values: AdminTypeProps): RegisterStrategy | never => {
  const map = {
    firm: !!values.fcaNumber,
    club: !!values.club,
  };

  if (map.firm) {
    return new FirmStrategy(values.fcaNumber);
  } else if (map.club) {
    return new ClubStrategy(values.club);
  }

  throw new Error('Strategy could not be created.');
};
